import {SynchronizationDataType, SynchronizationType} from "@/models/Enums";

export class SynchronizationRequest {

    public synchronizationDataType: SynchronizationDataType = SynchronizationDataType.OrganizationContracts;

    public synchronizationType: SynchronizationType = SynchronizationType.All;

    public syncFrom: Date | null = null;

    public customerExternalId: string | null = null;

    public includePrivateCustomers: boolean = false;

    public isSynchronizationRequest: boolean = true;
}